module.exports = __webpack_public_path__ + "static/media/2.5061474e.png";